<template>
  <div>

  </div>
</template>

<script>
import userApi from "@/api/user-api";
import { useLocalStorage } from "@vueuse/core";
import axios from "axios";

export default {
  props: ['apiKey'],
  name: "AuthView",
  data() {
    return {
      valid: null,
      loading: true,
    }
  },
  methods: {
    async getUser() {
      this.loading = true;
      try {
        axios.defaults.headers.common['x-api-key'] = this.apiKey;
        const user = await userApi.getUser();
        const state = useLocalStorage('hubble-chat-user', user);
        state.value = user;

        this.$nextTick(() => { // session storagen arvo ei päivity jos tätä ei aseteta
          this.$router.push({name: 'chat'});
        })
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$nextTick(() => {
          this.$router.push({name: 'notAuthenticated'});
          });
        }
        console.error(error);
      }
      this.loading = false;
    }
  },
  mounted() {
    console.log('mounted AuthView')
    this.getUser();
  }
}
</script>

<style scoped>

</style>
